class GPSProviderCollection extends App.Collections.BaseCollection {
    url = 'GPSProvider';
    model = App.Models.GPSProvider;
}

App.Collections.GPSProviders = GPSProviderCollection;
